<template>
  <div class="dashboard" style="max-width: 100%; padding-top: 4em;">
    <!-- <ul id="nav" style="padding-left: 2em; padding-right: 2em;">
      <li :class="{ active: $route.path === '/dealers/resellers' }"><router-link to="/dealers/resellers">{{ $t('dealers.resellers') }}</router-link></li>
      <li :class="{ active: $route.path === '/dealers/referrals' }"><router-link to="/dealers/referrals">{{ $t('dealers.referrals') }}</router-link></li>
    </ul> -->

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'dealers',
};
</script>